module.exports = {
  // API_SERVER: "https://papi.wellworld.id"
  API_SERVER: "https://api.wellworld.id"
  // API_SERVER: "http://165.22.254.225:14045"
};
